/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable no-redeclare */
import { StoredNotification } from '../model/StoredNotification';
import { StoredApplication } from '../model/Environment';
import { StoredStream } from '../model/StoredStream';

import { SettingsState } from './partials/Settings';
import { SearchState } from './partials/Search';
import { SortedNotificationsState } from './partials/Notification';

export type StoredApplicationMap = ReadonlyMap<string, StoredApplication>;
export type StoredStreamMap = ReadonlyMap<string, StoredStream>;

export type RootState = Readonly<{
  search: SearchState;
  notifications: StoredNotification[];
  stickyNotifications: StoredNotification[];
  applications: StoredApplicationMap;
  streams: StoredStreamMap;
  centerVisible: boolean;
  centerLocked: boolean;
  centerMuted: boolean;
  loggedIn: boolean;
  settings: SettingsState;
  sortedNotifications: SortedNotificationsState;
}>;

export type Immutable<T> = {
  readonly [K in keyof T]: T[K] extends Date
    ? T[K]
    : T[K] extends [infer U, infer V]
    ? Readonly<[Immutable<U>, Immutable<V>]>
    : T[K] extends (infer U)[]
    ? ReadonlyArray<U extends object ? Immutable<U> : U>
    : T[K] extends object
    ? Immutable<T[K]>
    : Readonly<T[K]>;
};

export function mutable<T>(value: Immutable<T[]>): T[];
export function mutable<T>(value: Immutable<T>): T;
export function mutable<T>(value: Immutable<T>): T {
  return value as T;
}
